"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixBold = fixBold;
const tex_syntax_1 = require("./tex-syntax");
function fixBold(tex) {
    return tex.replace(new RegExp(`\\\\bold\\s*(\\\\(${tex_syntax_1.color})(\\s+[a-zA-Z0-9]|${(0, tex_syntax_1.block)(2)}))`, "g"), "\\bold{$1}");
}
